
import { PartFilter } from "@/data/parts";
import MetricsIconRow from "../metrics-row/MetricsIconRow";

type SortOption = "none" | "rating-high" | "rating-low";

interface MetricsContentProps {
  rating: number;
  subcategory: string;
  sortBy: SortOption;
  onRatingClick?: () => void;
  requiresRoot: boolean;
  requiresWiring?: boolean;
  requiresPrinting?: boolean;
  requiresTools?: boolean;
  requiresPurchase?: boolean;
  printedParts?: string;
  hasShoppingLinks: boolean;
  filters: PartFilter[];
  onFilterToggle?: (filter: PartFilter) => void;
  activeFilters?: PartFilter[];
}

const MetricsContent = ({
  rating,
  subcategory,
  sortBy,
  onRatingClick,
  requiresRoot,
  requiresWiring = false,
  requiresPrinting = false,
  requiresTools = false,
  requiresPurchase = false,
  printedParts,
  hasShoppingLinks,
  filters,
  onFilterToggle,
  activeFilters = []
}: MetricsContentProps) => {
  return (
    <MetricsIconRow 
      rating={rating}
      sortBy={sortBy}
      onRatingClick={onRatingClick}
      requiresRoot={requiresRoot}
      requiresWiring={requiresWiring}
      requiresPrinting={requiresPrinting}
      requiresTools={requiresTools}
      requiresPurchase={requiresPurchase}
      subcategory={subcategory}
      filters={filters}
      onFilterToggle={onFilterToggle}
      activeFilters={activeFilters}
      isDesktop={true}
    />
  );
};

export default MetricsContent;
